import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Input,
  InputGroup,
  InputGroupText,
  Alert,
} from "reactstrap";

import { FetchData, UploadFile } from "./utils/DataFetch";
import { GetCookie, Timeout } from "./utils/Common";

const moment = require("moment");

function toSendEmailRequest(model) {
  return {
    Body: model.Body,
    EmailCC: model.EmailCC,
    EmailTo: model.EmailTo,
    EmailType: model.EmailType,
    JobIds: model.JobIds,
    JobNums: model.JobNums,
    Subject: model.Subject
  };
}

export class InterpreterFormEmail extends Component {
  static displayName = InterpreterFormEmail.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie("user"));
    this.state = {
      model: props.model,
      showButtons: props.showButtons == null ? "send_email" : props.showButtons,
      activeTab: "1",
    };

    this.handleChange = this.handleChange.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
    this.sendCancelationEmail = this.sendCancelationEmail.bind(this);
    this.sendCoveringEmail = this.sendCoveringEmail.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
  }

  handleChange(e) {
    let model = { ...this.state.model };
    model[e.target.name] = e.target.value;

    this.setState({ model });
  }

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
      }
    );
  }

  sendEmail() {
    FetchData("/sendintemail", "POST", this.user.token, toSendEmailRequest(this.state.model)).then(
      (data) => {
        if (data === "Success") {
          this.props.handleSaveEventSuccess({
            message:
              data === "Success" ? "Email has been sent successfully" : data,
            modal: data === "Success" ? false : true,
            color: data === "Success" ? "success" : "warning",
          });
        } else {
          this.handleSaveEventSuccess({
            message:
              data === "Success" ? "Email has been sent successfully" : data,
            modal: data === "Success" ? false : true,
            color: data === "Success" ? "success" : "warning",
          });
        }
      }
    );
  }

  sendCoveringEmail() {
    const flagSnapshot = this.props.job
      ? {
          remClaimFlg: this.props.job.remClaimFlg,
          remIntFlg: this.props.job.remIntFlg,
          remProvFlg: this.props.job.remProvFlg,
          repAuthorizedFlg: this.props.job.repAuthorizedFlg,
          clmConfFlg: this.props.job.clmConfFlg,
          provConfFlg: this.props.job.provConfFlg,
        }
      : null;

    FetchData(
      "/SendIntCoveringEmail",
      "POST",
      this.user.token,
      toSendEmailRequest(this.state.model)
    ).then((data) => {
      // saving covering email
      var formData = new FormData();
      formData.append("EventType", "insert");
      formData.append("JobHistoryId", null);
      formData.append("JobId", this.props.job.jobId);
      formData.append("Description", this.state.model.Body);
      formData.append("JobHistoryType", "Covering Email");
      formData.append("CreateByUserId", this.user.userid);

      UploadFile("/savejobhistory", this.user.token, formData).then(
        (data) => {}
      );

      // saving my job
      var formData2 = new FormData();
      formData2.append("EventType", "insert");
      formData2.append("JobHistoryId", null);
      formData2.append("JobId", this.props.job.jobId);
      formData2.append(
        "Description",
        moment().format("MM/DD") + " Waiting for Int. Booking. Conf."
      );
      formData2.append("JobHistoryType", "My Job");
      formData2.append("CreateByUserId", this.user.userid);

      UploadFile("/savejobhistory", this.user.token, formData2).then((data) => {
        if (data === "Success") {
          if (this.props.onCoveringEmailSent && this.props.job?.jobId) {
            this.props.onCoveringEmailSent(
              this.props.job.jobId,
              flagSnapshot
            );
          }
          this.props.handleSaveEventSuccess({
            message:
              data === "Success" ? "Email has been sent successfully" : data,
            modal: data === "Success" ? false : true,
            color: data === "Success" ? "success" : "warning",
          });
        } else {
          if (this.props.onCoveringEmailSent && this.props.job?.jobId) {
            this.props.onCoveringEmailSent(
              this.props.job.jobId,
              flagSnapshot
            );
          }
          this.handleSaveEventSuccess({
            message:
              data === "Success" ? "Email has been sent successfully" : data,
            modal: data === "Success" ? false : true,
            color: data === "Success" ? "success" : "warning",
          });
        }
      });
    });

    //alert(moment().format('MM/DD'));
  }

  sendCancelationEmail() {
    if (
      window.confirm(
        "Your about to send a cancellation email to the interpreter, are you sure?"
      )
    ) {
      let workorder = this.state.model;
      //let model = {
      //    UserID: this.user.userid,
      //    FirstName: this.user.firstname,
      //    LastName: this.user.lastname,
      //    Email: this.user.email,
      //    JobId: workorder.JobIds,
      //    IntId: workorder.IntId
      //};

      FetchData(
        "/interpretersendcancelinterpreteremail/?jobId=" + workorder.JobIds,
        "POST",
        this.user.token,
        toSendEmailRequest(this.state.model)
      ).then((data) => {
        if (data === "Success") {
          this.props.handleSaveEventSuccess({
            message:
              data === "Success" ? "Email has been sent successfully" : data,
            modal: data === "Success" ? false : true,
            color: data === "Success" ? "success" : "warning",
          });
        } else {
          this.handleSaveEventSuccess({
            message:
              data === "Success" ? "Email has been sent successfully" : data,
            modal: data === "Success" ? false : true,
            color: data === "Success" ? "success" : "warning",
          });
        }
        //this.props.handleSaveEventSuccess({
        //    message: data === 'Success' ? "Email has been sent successfully" : data,
        //    modal: data === 'Success' ? false : true,
        //    color: data === 'Success' ? "success" : "warning"
        //});
      });
    }
  }

  componentDidMount() {
    //document.addEventListener('keydown', this.keydownHandler);
  }

  componentWillUnmount() {
    //document.removeEventListener('keydown', this.keydownHandler);
  }

  render() {
    return (
      <Modal
        isOpen={this.props.modal}
        toggle={this.props.setModal}
        style={{ width: "1024px", height: "600px" }}
        backdrop="static"
      >
        <ModalHeader>Interpreter Email</ModalHeader>
        <ModalBody>
          <div>
            <Row>
              <Col>
                <Alert
                  color={this.props.alert.color}
                  isOpen={this.props.alert.isOpen}
                >
                  {this.props.alert.message}
                </Alert>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup size="sm">
                  <InputGroupText className="no-border">
                    Email To:
                  </InputGroupText>
                  <Input
                    name="EmailTo"
                    className="form-control form-control-text"
                    placeholder="Email To"
                    value={this.state.model.EmailTo}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup size="sm">
                  <InputGroupText
                    className="no-border"
                    style={{ width: "54px" }}
                  >
                    CC:
                  </InputGroupText>
                  <Input
                    name="EmailCC"
                    className="form-control form-control-text"
                    placeholder="CC Email"
                    value={this.state.model.EmailCC}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup size="sm">
                  <InputGroupText
                    className="no-border"
                    style={{ width: "54px" }}
                  >
                    Subject:
                  </InputGroupText>
                  <Input
                    name="Subject"
                    className="form-control form-control-text"
                    placeholder="Subject"
                    value={this.state.model.Subject}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <textarea
                  name="Body"
                  rows="15"
                  className="no-border form-control-text"
                  style={{ width: "100%" }}
                  onChange={this.handleChange}
                >
                  {this.state.model.Body}
                </textarea>
              </Col>
            </Row>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            size="sm"
            onClick={this.sendCancelationEmail}
            hidden={
              this.state.showButtons.includes("cancellation") ? null : "hidden"
            }
          >
            Send Cancellation
          </Button>
          {/*<Button color="secondary" size="sm" hidden={this.state.showButtons.includes("remote_email") ? null : "hidden"}>Remote Email</Button>*/}
          <Button
            color="secondary"
            size="sm"
            onClick={this.sendCoveringEmail}
            hidden={
              this.state.showButtons.includes("covering_email")
                ? null
                : "hidden"
            }
          >
            Covering Email
          </Button>
          <Button color="secondary" size="sm" onClick={this.sendEmail}>
            Send Email
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}
